import {inject, Injectable} from '../di';
import {ConfigService} from '../config/config-service';
import {PageType} from '../../types/page-type';

@Injectable()
export class UtilsService {
  private readonly configService = inject(ConfigService);

  constructor() {
    window.getPageType = this.getPageType.bind(this);
  }

  /**
   * Get page type
   */
  public getPageType(): PageType {
    const config = this.configService.config;

    if (config.tv?.use_imagewide) {
      return PageType.ImageWide;
    }

    return config.tv?.page_type || PageType.Standard;
  }
}

declare global {
  interface Window {
    /**
     * @deprecated
     */
    getPageType: UtilsService['getPageType'];
  }

  /**
   * @deprecated
   */
  const getPageType: UtilsService['getPageType'];
}
